module.exports = __webpack_public_path__ + "img/avatar.6f680662.jpg";